import { render } from "./categoryattributelistshared.vue?vue&type=template&id=ba929866&scoped=true"
import script from "./categoryattributelistshared.vue?vue&type=script&lang=js"
export * from "./categoryattributelistshared.vue?vue&type=script&lang=js"

import "./categoryattributelistshared.vue?vue&type=style&index=0&id=ba929866&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba929866"]])

export default __exports__